import React, { useMemo } from 'react';

import { OtherIndividualInfo, PersonalInfo } from '../../../../domain/person';
import { AddressView } from '../../../../general/components/address-view';
import { DetailsRow, ReviewDetailsGrid } from '../review-grid';

type Props = {
  personalInfo: PersonalInfo | OtherIndividualInfo;
  includeOwnerInfo: boolean;
  includeControlInfo: boolean;
};

const PersonReviewDetails: React.FC<Props> = ({ personalInfo, includeControlInfo, includeOwnerInfo }: Props) => {
  const details: DetailsRow[] = useMemo(() => {
    const common = [
      {
        label: 'Full Name',
        value: `${personalInfo.firstName} ${personalInfo.lastName}`,
      },
      {
        label: 'DOB',
        value: <span data-private>{personalInfo.dob}</span>,
      },
      {
        label: 'Address',
        value: <AddressView address={personalInfo.address} />,
      },
    ];

    const withOwnerInfo = includeOwnerInfo
      ? [
          ...common,
          {
            label: 'Owns 25% or more of the company',
            value: personalInfo.beneficialOwner ? 'Yes' : 'No',
          },
        ]
      : common;

    return includeControlInfo
      ? [
          ...withOwnerInfo,
          {
            label: 'Has significant management responsibility',
            value: personalInfo.controlPerson ? 'Yes' : 'No',
          },
        ]
      : withOwnerInfo;
  }, [personalInfo, includeOwnerInfo, includeControlInfo]);
  return <ReviewDetailsGrid details={details} label={`${personalInfo.firstName} ${personalInfo.lastName}`} />;
};

export { PersonReviewDetails };
